import axios from 'axios';
import { Url } from '@wix/da-url';
import { all, call, put, select, takeEvery } from 'redux-saga/effects';
import {
  getCsrfToken,
  getCurrentUser,
} from '@wix/da-shared-react/pkg/publicSession/selectors';
import {
  setErrorMessage,
  setIsEditorOpen,
  uploadAvatar,
} from '../actions/avatar';
import logger from '../utils/logger';
import { normalize } from '@wix/da-shared-react/pkg/redux/normalizr';
import { userSchema } from '@wix/da-shared-react/pkg/redux/normalizr/schemas/user';

// TODO: move
import { cropImage } from '../components/UserWidgets/ProfileIdentity/AvatarEdit/ImageCrop/cropImage';
import {
  MAXIMUM_GIF_AVATAR_FILESIZE,
  MAXIMUM_AVATAR_FILESIZE,
  IMAGE_QUALITY,
} from '../components/UserWidgets/ProfileIdentity/AvatarEdit/constants';

function dapiPost(endpoint, data, options) {
  if (process.env.NODE_ENV !== 'production') {
    return Promise.resolve({ content: true });
  }
  return axios
    .request({
      method: 'post',
      baseURL: Url.buildFromPath('dapi/v1/dauserprofile'),
      url: `/${endpoint}`,
      ...options,
      data,
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return false;
    });
}

const file2base64 = file =>
  new Promise(resolve => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(file);
  });

function* updateUserAvatar(usericon) {
  const currentUser = yield select(getCurrentUser);
  const normalizedData = normalize({ ...currentUser, usericon }, userSchema);
  yield put({ type: 'TRIGGER.NORMALIZR.UPDATE', ...normalizedData });
}

function* toBlob({ file, image, pixelCrop }) {
  if (!file) {
    throw new Error('widgets.avatarEdit.error.noFileChosen');
  }
  if (!image) {
    throw new Error('widgets.avatarEdit.error.cannotProcessFile');
  }

  const blob = yield call(cropImage, file, image, pixelCrop, IMAGE_QUALITY);

  switch (blob.type) {
    case 'image/gif':
      if (blob.size > MAXIMUM_GIF_AVATAR_FILESIZE) {
        throw new Error('widgets.avatarEdit.error.maximumGifFileSizeExceeded');
      }
      break;
    case 'image/jpeg':
    case 'image/png':
      if (blob.size > MAXIMUM_AVATAR_FILESIZE) {
        throw new Error('widgets.avatarEdit.error.maximumFileSizeExceeded');
      }
      break;
    default:
      // unknown type
      throw new Error('widgets.avatarEdit.error.unexpectedErrorOccurred');
  }
  return blob;
}

export function* uploadAvatarSaga(action) {
  const { payload } = action;
  try {
    const { file, image, pixelCrop } = payload;
    const blob = yield call(toBlob, { file, image, pixelCrop });

    const options = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      withCredentials: true,
    };
    const formData = new FormData();
    formData.append('file', blob, file.name);
    formData.append('_csrf', yield select(getCsrfToken));
    const response = yield call(dapiPost, 'avatar/set', formData, options);

    if (response && response.content) {
      const usericon = yield call(file2base64, blob);
      yield call(updateUserAvatar, usericon);
      yield put(setIsEditorOpen(false));
    }
  } catch (err) {
    logger.error('uploadAvatarSaga', err);
    yield put(setErrorMessage(err.message));
  }
}

export default function* rootAvatarSaga() {
  yield all([takeEvery(uploadAvatar, uploadAvatarSaga)]);
}
